define('home/models/Announcement',[
    'backbone',
], function (
    Backbone
) {
    'use strict';

    var Announcement = Backbone.Model.extend({
        defaults: {
            subject: null,
            title: null,
            body: null,
            name: null,

            // optional
            // link
            // callToAction
            // image
        },
    });

    return Announcement;
});

